import { render } from "./Entrance.vue?vue&type=template&id=ace534a8"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"

import "./Entrance.vue?vue&type=style&index=0&id=ace534a8&lang=scss"
script.render = render

export default script